import { Typography } from 'shared/ui/Typography'
import { WidgetItem } from 'pages/chatbot/ui/UnifiedAgent/ui/Chat/ui/Widgets'
import { YES_NO_OPTIONS } from 'pages/chatbot/ui/UnifiedAgent/ui/InstructionsSection/store/actionsWidgetStore'
import styles from 'pages/chatbot/ui/UnifiedAgent/ui/InstructionsSection/styles.module.scss'

type IActionsStep1Props = {
  focusedIndex: number
  onSelect: (index: number) => void
}

export const ActionsStep1 = ({ focusedIndex, onSelect }: IActionsStep1Props) => (
  <div className={styles.list}>
    {YES_NO_OPTIONS.map((option, index) => (
      <WidgetItem
        key={option.id}
        isFocused={index === focusedIndex}
        badgeIndex={index}
        onClick={() => onSelect(index)}
      >
        <Typography variant={'body-rg-regular'} ariaLabel={option.label}>
          {option.label}
        </Typography>
      </WidgetItem>
    ))}
  </div>
)
